import styled from 'styled-components';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { NextSeo } from 'next-seo';
import { GET } from 'src/utils/services';
import { timestamp } from 'src/utils/helper';
import dynamic from 'next/dynamic';
import { APP_IMG } from 'src/constants';

const Layout = dynamic(import('src/components/layouts'));
const CardV = dynamic(import('src/components/cards/card-v'));
const Carousels = dynamic(import('src/components/carousels'));

const EmptyArticle = ({ type, data, lastNews, sessionSevId }) => {
  const [dataLatestNews, setDataLatestNews] = useState(lastNews);

  useEffect(() => {
    if (!lastNews) {
      (async () => {
        try {
          const uri = '/api/v1.0/categories/latest-news';
          const data = await GET(uri);
          // console.log(data);
          if (!_.isEmpty(data)) setDataLatestNews(data);
        } catch (err) {
          console.error(`${timestamp()}==========> EMPTY_ARTICLE ERROR : ${err}`);
        }
      })();
    }
  }, []);
  return (
    <Layout sessionSevId={sessionSevId}>
      <NextSeo
        noindex={true}
        nofollow={true}
        title='ไม่มีข่าวนี้หรือถูกลบไปแล้ว >>> Spring News'
        description='ไม่มีข่าวนี้หรือถูกลบไปแล้ว >>> Spring News'
      />
      <EmptyArticleStyle className='empty-article'>
        <div className='container'>
          <img
            className='no-article'
            src={`${APP_IMG}/static/spring_logo_Black.png`}
            loading='lazy'
            alt='no-article'
            title='no-article'
            width='100%'
            height='100'
          />
          {/* ----------------------------- LATEST_NEWS  --------------------------------- */}
          {Array.isArray(dataLatestNews) && (
            <Carousels slideShow={4}>
              {dataLatestNews.slice(0, 6).map((item, index) => (
                <div key={index} className='pe-0 pe-md-4'>
                  <CardV data={item} path={item.link} />
                </div>
              ))}
            </Carousels>
          )}
        </div>
      </EmptyArticleStyle>
    </Layout>
  );
};

const EmptyArticleStyle = styled.div`
  display: block;
  text-align: center;

  .card-wrapper {
    text-align: start;
  }

  .no-article {
    width: auto;
    margin: 100px auto;
    opacity: 0.3;
    -webkit-filter: grayscale(40%);
    filter: grayscale(40%);
    @media (max-width: 475px) {
      margin: 38px auto;
    }
  }
`;
export default EmptyArticle;
